import * as React from "react";
import { useEffect } from "react";
import { Box, Button, ButtonGroup, Card } from "@material-ui/core";
import PropTypes from 'prop-types';
import { WizardGeneral } from "./move-wizard-general";
import { WizardDetails } from "./move-wizard-details";
import { WizardCosting } from "./move-wizard-costing";

interface WizardProps {
  data: any;
  onStepChange?: (step: number) => void;
}

// Tab-like navigation: one page open at a time, switched by the buttons below
// the Action name (no Next/Back), mirroring the Activity Chain open/close UX.
const steps = [
  { key: 'essentials', label: 'Action details' },
  { key: 'planning', label: 'Action Planning' },
  { key: 'move_details', label: 'Costing of the Action' },
];

export const Wizard: React.FC<WizardProps> = (props) => {
  const { onStepChange } = props;
  const [activeStep, setActiveStep] = React.useState(0);

  // Let the parent dialog know the current step (so it can hide the persistent
  // Comment/Concerning header on pages other than the first).
  useEffect(() => {
    onStepChange && onStepChange(activeStep);
  }, [activeStep]);

  return (
    <Box sx={{ width: "100%" }}>
      <ButtonGroup fullWidth sx={{ mb: 2 }}>
        {steps.map((step, index) => (
          <Button
            key={step.key}
            color="success"
            variant={activeStep === index ? 'contained' : 'outlined'}
            onClick={() => setActiveStep(index)}
          >
            {step.label}
          </Button>
        ))}
      </ButtonGroup>

      <Card>
        {activeStep === 0 && <WizardGeneral />}
        {activeStep === 1 && <WizardDetails />}
        {activeStep === 2 && <WizardCosting />}
      </Card>
    </Box>
  );
};

Wizard.propTypes = {
  data: PropTypes.object
};
